


















































import Vue from "vue";
import moment from "moment";
import { GetUserLongTasksCommand } from "@/model/communication/userLongTasks/GetUserLongTasksCommand";
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { UserLongTask, UserLongTaskStatus } from "@/model/data/userLongTasks/UserLongTask";
import DownloadFileIconButton from "@/components/DownloadFileIconButton.vue";
import { mapGetters } from "vuex";

export default Vue.extend({
    components: {
        DownloadFileIconButton,
    },
    data() {
        return {
            userLongTaskPollingTimer: null,
            UserLongTaskStatus,
            loading: false,
            userLongTaskList: [],
            downloadTask: {},
            headers: [
                {
                    text: this.$t("common.status"),
                    value: "status",
                },
                {
                    text: this.$t("common.type"),
                    value: "type",
                },
                {
                    text: "ID",
                    value: "id",
                },
                {
                    text: this.$t("common.createdAt"),
                    value: "createdAt",
                },
                {
                    text: this.$t("common.completedAt"),
                    value: "completedAt",
                },
                {
                    text: this.$t("common.info"),
                    value: "info",
                },
                {
                    text: this.$t("common.actions"),
                    value: "actions",
                },
            ],
        };
    },
    methods: {
        async getUserLongTasks() {
            this.loading = true;

            let res = await new GetUserLongTasksCommand().execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                this.userLongTaskList.splice(0, this.userLongTaskList.length, ...res.userLongTaskList);
            }
            if (this.userLongTaskPollingTimer != null && (this.userLongTaskList as UserLongTask[]).filter((ult) => ult.status == UserLongTaskStatus.running).length == 0)
                clearInterval(this.userLongTaskPollingTimer);
            this.loading = false;
        },

        getStatusMessage(val: UserLongTaskStatus) {
            if (val == UserLongTaskStatus.completed) return this.$t("common.completed");
            if (val == UserLongTaskStatus.running) return this.$t("common.running");
            return "unknown";
        },

        getElapsedTime(from: Date, to: Date) {
            return `${this.$t("user_preferences.completed")} in ${moment.duration(moment(to).diff(moment(from))).humanize()}`;
        },
    },
    computed: {
        ...mapGetters(["notificationsPollingIntervalSec"]),
    },
    created() {
        this.getUserLongTasks();
        let longTaskPollingInterval = this.notificationsPollingIntervalSec == null ? 15000 : this.notificationsPollingIntervalSec;
        this.userLongTaskPollingTimer = setInterval(() => {
            this.getUserLongTasks();
        }, longTaskPollingInterval);
    },
    beforeDestroy() {
        if (this.userLongTaskPollingTimer != null) clearInterval(this.userLongTaskPollingTimer);
    },
});
